<template>
	<div id="main">
		<div class="bg-other user-head-info">
			<div class="user-info clearfix">
				<div class="user-pic" data-is-fans="0" data-is-follows="">
					<div class="user-pic-bg">
						<img class="img" :src="this.$store.state.sessionInfo.headimgurl" alt="">
					</div>
				</div>
				<div class="user-info-right">
					<h3 class="user-name clearfix">
						<span>{{this.$store.state.sessionInfo.wxNickName}}</span>
						</h3>
					<p class="about-info">
						<span>{{this.$store.state.sessionInfo.roleInfo.roleName}}</span>
					</p>
				</div>
				<div class="study-info clearfix">
					<div class="item follows">
						<div class="u-info-learn" :title="'直播时长' + zbSumsStr" style="cursor:pointer;">
							<em>{{zbSumsStr}}</em>
							<span>直播时长</span>
						</div>
					</div>
					<div class="item follows">
						<a href="#"><em>{{countObj.zbCounts}}</em></a>
						<span>直播次数</span>
					</div>
					<div class="item follows">
						<a href="#"><em>{{countObj.classCounts}}</em></a>
						<span>我的班级</span>
					</div>
					<div class="item follows">
						<a href="#"><em>{{countObj.stCounts}}</em></a>
						<span>我的学生</span>
					</div>
				</div>
			</div>
		</div>
		<div class="wrap">
			<div class="slider">
				<ul>
					<li>
						<a class="active" @click="toTcCenter">
							<i class="fa fa-users" aria-hidden="true"></i><span>我的班级</span><b class="icon-drop_right"></b>
						</a>
					</li>
					<li>
						<a>
							<i class="fa fa-list-ul" aria-hidden="true"></i><span>我的课程</span><b class="icon-drop_right"></b>
						</a>
					</li>
				</ul>
			</div>
			<div class="u-container">
				<div class="c-tab clearfix">
					<div class="tool-left l">
						<a class="sort-item" :class="{active:3 == liveIndex}" @click="getAllLive(3)">全部</a>
						<a class="sort-item" :class="{active:0 == liveIndex}" @click="getLive(0)">直播班</a>
						<a class="sort-item" :class="{active:1 == liveIndex}" @click="getLive(1)">正式班</a>
						<a class="sort-item" :class="{active:2 == liveIndex}" @click="getLive(2)">结业班</a>
					</div>
				</div>
				<div class="all-course-main" v-if="liveList.length > 0">
					<div class="allcourse-content js-course-list ">
						<div class="courseitem tl-item" v-for="item of liveList" :key="item.id">
							<div class="img-box">
								<a target="_blank">
									<img width="200" height="116" src="//img4.sycdn.imooc.com/szimg/5a39cd3f0001c09805400300-360-202.jpg">
								</a>
							</div>
							<div class="info-box course-list">
								<div class="title">
									<span v-if="item.liveFlag===0">直播班</span>
									<span v-if="item.liveFlag===1">正式班</span>
									<span v-if="item.liveFlag===2">结业班</span>
									<a class="hd" target="_blank">{{item.className}}</a>
								</div>
								<div class="catog-points">
									<a @click="classCrud(item.id)" class="btn-red crud-btn">班级管理</a>
									<a @click="stCrud(item.id)" class="btn-red continute-btn">学生管理</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="not-conts" v-if="liveList.length == 0">
					你还没有该类型的班级，可以
					<a class="find-course">联系管理员分配</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'TcCenterContent',
		data() {
			return {
				countObj: null,
				zbSumsStr: null,
				list: [],
				liveList: [],
				liveIndex: 3
			}
		},
		methods: {
			toTcCenter() {
				this.$router.push({
					path: '/center/tcCenter'
				})
			},
			getAllLive(i) {
				this.liveIndex = i
				this.liveList = this.list
			},
			getLive(i) {
				this.liveIndex = i
				let arr = []
				for(var o of this.list) {
					if(o.liveFlag == i) {
						arr.push(o)
					}
				}
				this.liveList = arr
			},
			classCrud(id) {},
			stCrud(id) {
				let routeUrl = this.$router.resolve({
					path: '/center/tcitem?cid=' + id
				})
				window.open(routeUrl.href, '_blank')
			},
			queryList() {
				axios.get('/itmswcn/maintain/classInfo/queryList')
					.then(this.queryListSucc)
			},
			queryListSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.list = data
					this.liveList = this.list
				}
			},
			countCi() {
				axios.get('/itmswcn/maintain/classInfo/countCi')
					.then(this.countCiSucc)
			},
			countCiSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
					this.countObj = data
					this.zbSumsStr = Math.round(data.zbSums / 3600) + 'h'
				}
			}
		},
		mounted() {
			this.countCi()
			this.queryList()
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/center/components/StCenterContent.scss';
</style>